import React from "react";

const CandidateFileIcon = () => (
  <svg width="40" height="53" viewBox="0 0 40 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 6.625C0 3.00195 2.91667 0 6.66667 0H23.3333V13.25C23.3333 15.1133 24.7917 16.5625 26.6667 16.5625H40V46.375C40 50.1016 36.9792 53 33.3333 53H6.66667C2.91667 53 0 50.1016 0 46.375V6.625ZM40 13.25H26.6667V0L40 13.25Z" fill="#5A2AF1" />
  </svg>
);

export default CandidateFileIcon;
